import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@rd/shared-legacy/components/button/button.module';
import { IconModule } from '@rd/shared-legacy/components/icon/icon.module';
import { DialogDefaultTemplateComponent } from './components/default-template/default-template.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { LeaveConfirmationDialogComponent } from './components/leave-confirmation-dialog/leave-confirmation-dialog.component';
import { PopupPromptDialogComponent } from './components/prompt-dialog/prompt-dialog.component';
import { PopupSortDialogComponent } from './components/sort-dialog/sort-dialog.component';
import { DialogClosedFocusModule } from './dialog-closed-focus.module';
import { DialogService } from './services/dialog/dialog.service';

const declaredComponents: any[] = [
  DialogComponent,
  DialogDefaultTemplateComponent,
  LeaveConfirmationDialogComponent,
  PopupPromptDialogComponent,
  PopupSortDialogComponent,
];

const exportComponents: any[] = [
  DialogDefaultTemplateComponent,
  LeaveConfirmationDialogComponent,
  PopupPromptDialogComponent,
  PopupSortDialogComponent,
];

@NgModule({
  declarations: [...declaredComponents],
  imports: [
    CommonModule,
    DialogClosedFocusModule,
    ButtonModule,
    IconModule,
    TranslateModule,
  ],
  exports: [...exportComponents],
  providers: [DialogService],
})
export class PopupModule {}
